import { styled } from '@material-ui/core';
import { colorLuminance, validateHexColor } from 'utils/colorUtils';

const getColourFromVariant = (variant, theme, color) => {
  if (validateHexColor(color)) {
    return color;
  } else {
    switch (variant) {
      case 'inactive':
        return theme.palette.xpl.message.trivial.background; //'#E5E6EC' ;
      case 'error':
        return theme.palette.xpl.message.negative.background; //#FED9D5
      case 'warning':
        return theme.palette.xpl.message.hightlight.background; //'#ECFD91';
      case 'success':
        return theme.palette.xpl.message.positive.background; //'#C4FFED';
      case 'default':
        return theme.palette.xpl.message.information.background; //'#EBE5FF';
      default:
        return theme.palette.xpl.message.information.background; //'#EBE5FF';
    }
  }
};
const getDotColourFromVariant = (variant, theme, color) => {
  if (validateHexColor(color)) {
    const dotColor = colorLuminance(color, -0.5);
    return dotColor;
  } else {
    switch (variant) {
      case 'inactive':
        return theme.palette.xpl.message.trivial.default; //'#6A6D7D';
      case 'error':
        return theme.palette.xpl.message.negative.default; //#DB321F
      case 'warning':
        return theme.palette.xpl.message.hightlight.default; //'#ADAB20';
      case 'success':
        return theme.palette.xpl.message.positive.default; //'#37B88F';
      case 'default':
        return theme.palette.xpl.message.information.default; //'#6923F4';
      default:
        return theme.palette.xpl.message.information.default; //'#6923F4';
    }
  }
};
export const BadgeContainer = styled('span')(
  ({ theme, variant, dot, color }) => {
    let badgeStyle = {
      borderRadius: '12px',
      whiteSpace: 'nowrap',
      background: `${getColourFromVariant(variant, theme, color)}`,
      padding: '2px 12px 4px 12px',
      color: theme.palette.xpl.text.primary,
      border: '0px',
      fontWeight: '500',
      lineHeight: '20px',
      fontSize: '14px',
    };
    if (dot) {
      badgeStyle['&::before'] = {
        height: '8px',
        width: '8px',
        borderRadius: '50%',
        display: 'inline-block',
        margin: '0 4px 1px -5px',
        content: '""',
        backgroundColor: `${getDotColourFromVariant(variant, theme, color)}`,
      };
    }
    return badgeStyle;
  }
);
